export default __webpack_public_path__ + "static/media/youtube.1b7bb972.svg";